import React from 'react';
import ConfirmationWithRadio from './ConfirmationWithRadio/ConfirmationWithRadio';
import { ConfirmationWithRadioProps } from './ConfirmationWithRadio/ConfirmationWithRadio.props';

const ConfirmationWithRadioWrapper = (props: ConfirmationWithRadioProps) => <ConfirmationWithRadio {...props} />;

export default ConfirmationWithRadioWrapper;
